export default function (ModalService) {
    return function (vehicleId, keepers) {
        return ModalService.showModal({
            controller: require('../../controllers/keepers/create/keeperCreateCtrl'),
            template: require('../../controllers/keepers/create/keeper-create.html'),
            controllerAs: 'createKeeper',
            inputs: {
                vehicleId,
                keepers
            }
        })
        .then(modal => modal.close);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/openCreateKeeperModel.js